import myzod, { Infer } from 'myzod'
import { WEBSOCKET_MESSAGE_TYPES } from './websocketMessageTypes'

export const WebsocketResponseMessageSchema = myzod.object({
  scope: myzod.enum(WEBSOCKET_MESSAGE_TYPES),
  bodyType: myzod.string().optional(), // For Later use to describe body
  body: myzod.unknown(),
})
export type WebsocketResponseMessage = Infer<
  typeof WebsocketResponseMessageSchema
>
